export const reactToastify = {
  '.eds-react-toastify_toast-container': {
    maxHeight: '50vh',
    minHeight: 'unset',
    overflowY: 'auto',
    padding: 0,
    width: 'min-content',
  },
  '.Toastify__toast-container--bottom-center': {
    marginLeft: '0 !important',
    transform: 'translateX(-50%)',
  },
};
